
import { defineComponent, toRef } from "vue";
import Text from "@/Components/Utilities/Text.vue";

interface Props {
  errorMessage: string;
}

export default defineComponent({
  props: {
    errorMessage: {
      type: String,
      required: false,
      default: () => "",
    },
  },
  components: {
    Text,
  },
  setup(props: Props) {
    const errorMessage = toRef(props, "errorMessage");

    return {
      errorMessage,
    };
  },
});
